export const getApiErrorMessage = (error, fallback = 'Something went wrong. Please try again.') => {
  if (!error) return fallback;

  if (typeof error === 'string') return error.trim() || fallback;

  const body = error.data || error;
  const errors = body.errors || body.failure?.errors;

  if (errors && typeof errors === 'object' && !Array.isArray(errors)) {
    for (const key of Object.keys(errors)) {
      const value = errors[key];
      if (Array.isArray(value) && value.length && typeof value[0] === 'string') {
        return value[0];
      }
      if (typeof value === 'string' && value.trim()) {
        return value;
      }
      if (value?.message) {
        return value.message;
      }
    }
  }

  if (Array.isArray(errors) && errors.length) {
    const { first } = errors;
    if (typeof first === 'string') return first;
    if (first?.message) return first.message;
  }

  if (body.title) return body.title;

  const message = body.message || error.message;
  if (message) return message;

  return fallback;
};
